import { TransferTypeObject } from './interfaces'

export enum TransferType {
    STANDARD = "STANDAR",
    RAMP = "RAMPA",
    AMBULANCE = "AMBULANCIA"
  }

export const getTransferTypes = (t: (key: string) => string): TransferTypeObject[] => {
  return [
    {
      id: TransferType.STANDARD,
      value: t('appointmentTransfer.standardTransfer'),
    },
    {
      id: TransferType.RAMP,
      value: t('appointmentTransfer.rampTransfer'),
    },
    {
      id: TransferType.AMBULANCE,
      value: t('appointmentTransfer.ambulanceTransfer'),
    },
  ]
}

// Function to get transfer type ID from translation key
export const getTransferTypeId = (t: (key: string) => string, translationKey: string): TransferType => {
  const types = getTransferTypes(t)
  const type = types.find(type => type.value === t(translationKey))
  return type ? type.id : TransferType.STANDARD
}

// Function to get transfer type name from ID
export const getTransferTypeName = (t: (key: string) => string, id: TransferType): string => {
  const types = getTransferTypes(t)
  const type = types.find(type => type.id === id)
  return type ? type.value : ''
}


